import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import React, { useCallback } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import sendPurchaseMessageToNative from '../dispatchers/sendPurchaseMessageToNative';

function useHandleNativePurchaseOnClick() {
  const isNative = useIsNative();

  return useCallback(
    (
      event: React.MouseEvent<HTMLElement>,
      nativePayload: PurchaseEventPayload
    ) => {
      if (!isNative) return;

      event.preventDefault();

      sendPurchaseMessageToNative(
        DispatcherEvent.ContinuePurchase,
        nativePayload
      );
    },
    [isNative]
  );
}

export default useHandleNativePurchaseOnClick;
